<template>
  <div dir="rtl">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <v-container>
      <v-toolbar flat color="white">
        <v-toolbar-title>السلف</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="البحث"
          single-line
          hide-details
        ></v-text-field>

        <v-dialog
          v-model="add_dialog"
          max-width="500px"
          dir="rtl"
          align="right"
        >
          <v-btn slot="activator" color="primary" dark class="mb-2">جديد</v-btn>
          <v-card>
            <v-card-title>
              <span class="headline">اضافة سلفة</span>
            </v-card-title>

            <v-card-text>
              <v-form ref="form">
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm6 md4>
                      <v-autocomplete
                        v-model="select_employer"
                        :items="employers"
                        item-text="name"
                        item-value="id"
                        label="أختر الموظف"
                        persistent-hint
                        return-object
                        single-line
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.manger')"
                        data-vv-name="manger"
                        data-vv-scope="form1"
                      >
                        <template v-slot:append-outer>
                          <v-slide-x-reverse-transition mode="out-in">
                          </v-slide-x-reverse-transition>
                        </template>
                      </v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="newItem.money"
                        label="قيمة السلفة"
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.name')"
                        data-vv-name="name"
                        data-vv-scope="form1"
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md4>
                      <v-dialog
                        ref="dialog1"
                        v-model="modal1"
                        :return-value.sync="date1"
                        persistent
                        lazy
                        full-width
                        width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="date1"
                            label=" التاريخ اليدوي"
                            readonly
                            outline
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="date1" scrollable>
                          <v-spacer></v-spacer>
                          <v-btn flat color="primary" @click="modal1 = false"
                            >Cancel</v-btn
                          >
                          <v-btn
                            flat
                            color="primary"
                            @click="$refs.dialog1.save(date1)"
                            >OK</v-btn
                          >
                        </v-date-picker>
                      </v-dialog>
                    </v-flex>

                    <v-flex xs12 sm6 md12>
                      <v-textarea
                        label="الملاحظات"
                        v-model="newItem.note"
                      ></v-textarea>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="close">الغاء</v-btn>
              <v-btn color="blue darken-1" flat @click.native="save('form1')"
                >حفظ</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="edit_dialog"
          max-width="500px"
          dir="rtl"
          align="right"
        >
          <v-card>
            <v-card-title>
              <span class="headline">تعديل سلفة</span>
            </v-card-title>

            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md4>
                    اسم الموظف :
                    {{ editedItem.employer ? editedItem.employer.name : "" }}
                  </v-flex>

                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedItem.money"
                      label="المبلغ"
                      v-validate="'required'"
                      :error-messages="errors.collect('form2.name')"
                      data-vv-name="name"
                      data-vv-scope="form2"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md4>
                    <v-dialog
                      ref="dialog2"
                      v-model="modal2"
                      :return-value.sync="date2"
                      persistent
                      lazy
                      full-width
                      width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="date2"
                          label=" التاريخ اليدوي"
                          readonly
                          outline
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="date2" scrollable>
                        <v-spacer></v-spacer>
                        <v-btn flat color="primary" @click="modal2 = false"
                          >Cancel</v-btn
                        >
                        <v-btn
                          flat
                          color="primary"
                          @click="$refs.dialog2.save(date2)"
                          >OK</v-btn
                        >
                      </v-date-picker>
                    </v-dialog>
                  </v-flex>

                  <v-flex xs12 sm6 md12>
                    <v-textarea
                      label="الملاحظات"
                      v-model="editedItem.note"
                    ></v-textarea>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="close">الغاء</v-btn>
              <v-btn color="blue darken-1" flat @click="update('form2')"
                >حفظ</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="employer_solfas"
        class="elevation-1"
        :search="search"
        :loading="loading"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.employer ? props.item.employer.name : "" }}</td>
          <td>{{ props.item.money }}</td>
          <td>{{ props.item.created_at }}</td>
          <td>{{ props.item.note }}</td>
          <td class="justify-center layout px-0">
            <v-icon
              v-if="permissions.delete_all == 1 || user.type == 1"
              small
              class="ml-4"
              @click="editItem(props.item)"
            >
              edit
            </v-icon>
            <v-icon
              v-if="permissions.delete_all == 1 || user.type == 1"
              small
              @click="deleteItem(props.item)"
            >
              delete
            </v-icon>
          </td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
        <template slot="no-data">
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2">
        <v-pagination
          dark
          dir="rtl"
          class="mypagination"
          v-model="pagination.page"
          :length="pages"
          prev-icon="chevron_right"
          next-icon="chevron_left"
        ></v-pagination>
      </div>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import {
  employer_solfas,
  add_employer_solfa,
  update_employer_solfa,
  delete_employer_solfa
} from "../config/apiRoute.js";
export default {
  data: () => ({
    user: [],
    permissions: [],
    rowsPerPageItems: [400, 800],
    add_dialog: false,
    edit_dialog: false,
    select_employer: {},
    select_employer_edit: {},
    modal1: false,
    date1: new Date().toISOString().substr(0, 10),
    modal2: false,
    date2: new Date().toISOString().substr(0, 10),
    headers: [
      {
        text: "الموظف",
        align: "right",
        value: "employer.name"
      },
      {
        text: "المبلغ",
        align: "right",
        value: "money"
      },
      {
        text: "التاريخ",
        align: "right",
        value: "created_at"
      },
      {
        text: "الملاحظات",
        align: "right",
        value: "note"
      },
      { text: "التحكم", value: "control", sortable: false, align: "center" }
    ],

    search: "",
    loading: true,
    pagination: {
      rowsPerPage: 30,
      descending: true
    },
    employer_solfas: [],
    branchs: [],
    employers: [],
    mohafzas: [],
    cities: [],
    editedItem: {},
    newItem: {
      money: "",
      note: "",
      employer_id: ""
    }
  }),

  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    }
  },

  watch: {
    //    dialog (val) {
    //   val || this.close()
    // }
  },

  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));
    this.initialize();
  },

  methods: {
    initialize() {
      employer_solfas().then(response => {
        this.employer_solfas = response.data.solfas;
        this.employers = response.data.employers;
        this.pagination.totalItems = response.data.solfas.length;
        this.loading = false;
      });
    },

    editItem(item) {
      //   this.editedItem = Object.assign({}, item)
      this.initialize();
      this.editedIndex = this.employer_solfas.indexOf(item);
      this.editedItem = item;
      this.date2 = item.created_at;

      this.edit_dialog = true;
    },

    deleteItem(item) {
      this.$swal({
        title: "هل تريد الأستمرار",
        text: "سيتم الحذف نهائيا ولا يمكن الرجوع",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم !",
        cancelButtonText: "لا"
      }).then(result => {
        if (result.value) {
          const index = this.employer_solfas.indexOf(item);

          this.loading = true;
          var frmData2 = new FormData();
          delete_employer_solfa(frmData2, item.id).then(response => {
            this.loading = false;
            this.employer_solfas.splice(index, 1);
            this.close();
          });
        }
      });
    },

    close() {
      this.add_dialog = false;
      this.edit_dialog = false;
      //   setTimeout(() => {
      //     this.editedItem = Object.assign({}, this.defaultItem)
      //     this.editedIndex = -1
      //   }, 300)
    },

    save(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (valid) {
          this.loading = true;
          var frmData = new FormData();
          this.newItem.employer_id = this.select_employer.id;
          this.newItem.created_at = this.date1;
          frmData.append("hafez", JSON.stringify(this.newItem));

          add_employer_solfa(frmData).then(response => {
            // Object.assign(this.$data.newItem, this.$options.data().newItem);

            this.employer_solfas.push(response.data);
            this.loading = false;
            this.close();
            setTimeout(() => {
              this.$refs.form.reset();
            }, 1000);
          });
        }
      });
    },

    update(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (valid) {
          this.loading = true;
          let item_id = this.editedItem.id;

          this.editedItem.created_at = this.date2;

          var frmData = new FormData();
          frmData.append("hafez", JSON.stringify(this.editedItem));
          update_employer_solfa(frmData, item_id).then(response => {
            Vue.set(
              this.employer_solfas,
              this.employer_solfas.findIndex(f => f.id === item_id),
              response.data
            );
            this.loading = false;
            this.close();
          });
        }
      });
    }
  }
};
</script>

<style scope>
.v-datatable__actions__range-controls {
  display: none;
}
.v-dialog.v-dialog--active {
  direction: rtl;
}
.v-label.v-label--active {
  right: 0px !important;
}
.v-label.theme--light {
  right: 0px !important;
}
</style>
